var AutoLinker = require('autolinker');
var Buf = require("buf");
var Message = require('message');
var User = require("user");
var uriTemplates = require('uri-templates');
var IRCFormatter = require('ircformatter');
var FileWrapper = require('filewrapper');
var util = require('../lib/util.es6');
var twitch = require('../lib/twitch.es6');
var attachment = require('./attachment.es6');
var slackBlock = require('./slackBlock.es6');

var TWITCH_EMOTE_TEMPLATE = 'https://static-cdn.jtvnw.net/emoticons/v1/{emote_id}/{size}';

var Formatter = function () {
    this.linker = new AutoLinker(this);
};
Formatter.prototype = {
    makeDataAttributes: function (data) {
        var dataAttribs = {};
        for (var k in data) {
            if (data[k] != null) {
                dataAttribs['data-' + k] = data[k];
            }
        }
        return dataAttribs;
    },
    makeAttributes: function (attribs) {
        var dataAttribs = this.makeDataAttributes(attribs.data);
        delete attribs.data;
        attribs = _.extend(attribs, dataAttribs);
        var parts = [];
        for (var attr in attribs) {
            if (attribs[attr] != null) {
                if (attribs[attr] === true) {
                    parts.push(attr);
                } else {
                    parts.push(attr + '="' + this.escapeText(attribs[attr], {rawSpace: true}) + '"');
                }
            }
        }
        if (parts.length) {
            return ' ' + parts.join(' ');
        } else {
            return '';
        }
    },
    normaliseIdentifier: function (identifier) {
        identifier = IRCFormatter.strip(util.stringify(identifier)) || ' ';
        // Careful to fallback to unstripped version for syntax only nicks
        var stripped = identifier.toLowerCase()
            // remove @ or | till the end
            .replace(/[@|].*$/, '')
            // remove any leading syntax
            .replace(/^[\\[\]^_`{|}]+/, '')
            // remove all ` or _ suffixes
            .replace(/[`_]+$/, '')|| identifier;
        return stripped;
    },
    getReplyColorIndex: function (identifier) {
        return this.getNickColorIndex(identifier, {
            raw: true
        });
    },
    getNickColorIndex: function (identifier, options) {
        options = options || {};
        options.length = options.length || window.IRCConfig.nickColors;
        var stripped;
        if (options.raw) {
            stripped = identifier;
        } else {
            stripped = this.normaliseIdentifier(identifier);
        }

        // Hash the identifier
        var hash = 0;
        for (var i = 0; i < stripped.length; i++) {
            hash = stripped.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
        }

        // Get an index from the hash, update if adding colours
        var index = Math.abs(hash % options.length);
        return index;
    },
    imageAvatar: function (urlTemplate, self, options) {
        options = options || {};
        var size = options.size || 32;
        var attribs = {
            data: options.data
        };
        var className = 'avatar imageAvatar';
        if (!options.standalone) {
            className += ' imageAvatar--loading';
        }
        if (options.external && (!this.buffer || !this.buffer.connection.isSlackOAuth())) {
            className += ' imageAvatar--external';
        }
        if (self) {
            className += ' imageAvatar--self';
        }
        if (options.hasDataParent) {
            className += ' hasUserParent';
        }
        var avatar_1x = uriTemplates(urlTemplate).fill({
            size: size
        });
        var imgAttribs = {
            alt: ''
        };
        if (!options.standalone) {
            imgAttribs.src = avatar_1x;
            imgAttribs['class'] = 'irccloud_avatar';
        }
        if (avatar_1x != urlTemplate) {
            // Might not be a template
            className += ' imageAvatar--templated';
            if (!options.no2x) {
                imgAttribs.srcset = avatar_1x + ' 1x, ' + uriTemplates(urlTemplate).fill({
                    size: size * 2
                }) + ' 2x';
            }
        }
        attribs['class'] = className;
        var img = '<img' + this.makeAttributes(imgAttribs) + '>';
        return '<span' + this.makeAttributes(attribs) + '>' + img + '</span>';
    },
    avatar: function (nick, self, options) {
        options = options || {};
        var identifier = options.name || nick;
        // Careful to fallback to unstripped version for syntax only nicks
        var stripped = this.normaliseIdentifier(identifier);
        var firstLetter = String.fromCodePoint(
            stripped.toUpperCase().codePointAt(0)
        );
        var attribs = {
            data: options.data,
            title: options.title
        };
        var className = 'avatar letterAvatar';
        if (options.fallback) {
            var type;
            if (options.external && (!this.buffer || !this.buffer.connection.isSlackOAuth())) {
                type = 'external';
            } else {
                type = 'internal';
            }
            className += ' letterAvatar--' + type;
            // Delay fallback, starts hidden, will be shown after a timeout
            // via a css animation
            if (options.delayFallback) {
                className += ' letterAvatar--delay_fallback';
            }
        }
        if (options.hasDataParent) {
            className += ' hasUserParent';
        }
        if (!self) {
            if (options.color) {
                attribs['style'] = 'background-color: ' + this.escapeText(options.color) + ';';
                if (_.include(['#fff', '#ffffff', '#fefefe', 'white'], options.color.toLowerCase())) {
                    className += ' letterAvatar--white';
                }
            } else {
                var nickColor = this.getNickColorIndex(identifier);
                className += ' c' + nickColor;
            }
        } else {
            className += ' letterAvatar--self';
        }
        attribs['class'] = className;
        return '<span' + this.makeAttributes(attribs) + '><span role="presentation">' + this.escapeText(firstLetter) + '</span></span>';
    },
    renderTwitchBadges: function (message) {
        var tags = message.getTwitchTags();
        if (tags && tags['badges']) {
            var twitchBadges = '<span' + this.makeAttributes({
                'class': 'twitch_badges',
                data: {
                    twitch_badges: tags['badges'],
                    twitch_badge_info: tags['badge-info'],
                    twitch_room_id: tags['room-id']
                }
            }) + '></span>';
            return twitchBadges;
        }
        return '';
    },
    setDisplayAuthorProps: function (authorProps, displayAuthor, nick) {
        if (displayAuthor) {
            authorProps.name = displayAuthor;
            if (displayAuthor.toLowerCase() != nick.toLowerCase()) {
                authorProps.suffix = '<span class="actualName">&nbsp;(' + this.escapeText(nick) + ')</span>';
            }
        }
    },
    setTwitchAuthorProps: function (message, authorProps, nick) {
        authorProps.title = '';
        var tags = message.getTwitchTags();
        this.setDisplayAuthorProps(authorProps, tags['display-name'], nick);
        if (!message.isSelf() && tags['color']) {
            this.setAuthorColor(authorProps, tags['color']);
        }
    },
    setAuthorColor: function (authorProps, color) {
        authorProps.color = false;
        authorProps.styles = {
            'color': color
        };
        if (_.include(['#fff', '#ffffff', '#fefefe', 'white'], color.toLowerCase())) {
            authorProps.className += ' whiteNick';
        }
    },
    embedSpin: function () {
        return '<i class="spin embedSpin"></i>';
    },
    howLong: function (date, prefix) {
        var strings = Formatter[prefix ? 'HOW_LONG_STRINGS_PREFIX' : 'HOW_LONG_STRINGS'];
        var formattedText = '<span title="' + date.formatFullDate() + '">' + $.timeago(date, strings) + '</span>';
        return formattedText;
    },
    timestamp: function (date) {
        var formattedText = '<span class="timestamp" title="' + date.formatFullDate() + '">' + date.formatTime() + '</span>';
        return formattedText;
    },
    date: function (timestamp, format) {
        format = format || 'MMMM dd, yyyy';
        return new Date(timestamp * 1000).toString(format);
    },
    amountSign: function (amount) {
        if (amount < 0) {
            return '-';
        } else {
            return '';
        }
    },
    amount: function (currency, amount, multiplier, fixed) {
        if (fixed === undefined) {
            fixed = 2;
        }
        var curr = currency.toLowerCase();
        var value = (amount / 100);
        if (curr == 'btc') {
            value = value / 1000000;
        }
        if (multiplier) {
            value = value * multiplier;
        }
        var prefix = '';
        if (value < 0) {
            value = value * -1;
            prefix = '-';
        }
        if (fixed === 0 && value % 1 > 0) {
            fixed = 2;
        }
        return prefix + this.getCurrencySymbol(curr) + value.toFixed(fixed);
    },
    getCurrencySymbol: function (cur) {
        var symbols = {
            'usd': '$',
            'gbp': '£',
            'eur': '€',
            'btc': '฿'
        };
        return symbols[cur.toLowerCase()] || '';
    },
    escapeQuerySelector: function (text) {
        // TODO switch to CSS.escape or $.escapeSelector
        return util.stringify(text).replace(/([\\'"])/g, '\\$1');
    },
    escapeText: function (text, options) {
        return IRCFormatter.escapeHtml(text, options);
    },
    escapeTextMinimal: function (text, options) {
        return IRCFormatter.escapeHtmlMinimal(text, options);
    },
    escapeTextComicSans: function (text) {
        return IRCFormatter.escapeHtml(text);
    },
    isRtl: function (text) {
        return Formatter.RTL_REGEX.test(text);
    },
    pluralise: function (count, text, plural) {
        if (count == 1) {
            return text;
        } else {
            return plural || (text + 's');
        }
    },
    listSentence: function (parts, options) {
        options = options || {};
        var msg = '';
        _.each(parts, function (p, i) {
            if (i > 0) {
                if (!options.noAnd && i == parts.length - 1) {
                    msg += ' and ';
                } else {
                    msg += ', ';
                }
            }
            if (options.render) {
                msg += options.render(p, i);
            } else {
                msg += p;
            }
        });
        return msg;
    },
    renderProcessor: function (options, textPart, textIndex) {
        var part = {
            value: textPart,
            index: textIndex
        };
        return this.renderMatches(part, options);
    },
    render: function (lines, options) {
        lines = $.makeArray(lines);
        // Format parts
        var formattedLines = [];
        options = _.extend({}, options, {
            processor: _.bind(this.renderProcessor, this, options)
        });
        _.each(lines, function (text) {
            var formattedText = IRCFormatter.renderHtml(text, options);
            formattedLines.push(formattedText);
        }, this);
        // Join lines back up and return
        var formattedText = formattedLines.join('<br>');
        return formattedText;
    },
    renderMatches: function (part, options) {
        options = options || {};
        var tagOffsets = [];
        var matchOffsetTags = {
            start_offset: '<span class="match">',
            end_offset: '</span>'
        };
        var matchTokens = options.message && options.message.get('match_tokens');
        _.each(matchTokens, function (tok) {
            _.each(['start_offset', 'end_offset'], function (offsetName) {
                if (tok[offsetName] >= part.index && tok[offsetName] <= part.index + part.value.length) {
                    tagOffsets.push({
                        offset: tok[offsetName] - part.index,
                        name: offsetName
                    });
                }
            });
        });
        var index = 0;
        var value = part.value;
        var rendered = '';
        _.each(tagOffsets, function (tagOffset) {
            rendered += this.renderReplacements({
                value: part.value.slice(index, tagOffset.offset),
                index: part.index + index
            }, _.extend({}, options, {withPlain: true}));
            rendered += matchOffsetTags[tagOffset.name];
            value = part.value.slice(tagOffset.offset);
            index = tagOffset.offset;
        }, this);
        if (value) {
            rendered += this.renderReplacements({
                value: value,
                index: part.index + index
            }, options);
        }
        return rendered;
    },
    renderReplacements: function (part, options) {
        if (options.replacements) {
            var index = 0;
            var value = part.value;
            var rendered = '';
            _.each(options.replacements, function (replacement) {
                var rOffset = replacement.startOffset || 0;
                var rStart = rOffset + (replacement.start - part.index);
                var rEnd = rOffset + (replacement.end - part.index);
                if (
                    rStart >= 0 &&
                    rStart <= part.value.length &&
                    rEnd <= part.value.length
                ) {
                    rendered += this.renderTwitchCheer(util.stringSlice(part.value, index, rStart), options);
                    var replacementText = util.stringSlice(part.value, rStart, rEnd);
                    var plainClassName;
                    switch (replacement.type) {
                    case 'mention':
                        if (replacementText === replacement.nick) {
                            var name = replacement.nick;
                            if (this.buffer) {
                                var member = this.buffer.getMember(name);
                                var user;
                                var nickData;
                                if (options.mention_data && options.mention_data[name]) {
                                    user = this.buffer.connection.makeUserFromTarget(
                                        this.buffer.bid(),
                                        options.mention_data[name]
                                    );
                                } else if (member) {
                                    user = member;
                                } else {
                                    user = this.buffer.connection.makeUserFromTarget(
                                        this.buffer.bid(),
                                        { nick: name }
                                    );
                                }
                                var displayAuthor = user.getDisplayAuthor();
                                if (
                                    options.partOptions && options.partOptions.atMention &&
                                    displayAuthor && displayAuthor != name
                                ) {
                                    name = displayAuthor;
                                }
                                var className = 'mention';
                                if (!user.isSelf()) {
                                    className += ' c' + this.getNickColorIndex(displayAuthor || name);
                                }
                                rendered += this.linkUser(user, {
                                    noData: true,
                                    name: name,
                                    className: className
                                });
                            } else {
                                rendered += this.escapeText(name);
                            }
                        } else {
                            debug.warn("mention replacement doesn't match nick", replacement, options.message && options.message.toJSON());
                            rendered += this.escapeText(replacementText);
                        }
                        break;
                    case 'emoji':
                        var emoteSrc = replacement.url;
                        rendered += '<img' + this.makeAttributes({
                            'class': 'notCloseable customEmoji loading',
                            src: emoteSrc,
                            title: replacementText,
                            alt: replacementText
                        }) + '>';
                        plainClassName = 'customEmojiText';
                        break;
                    case 'twitch_emote':
                        var emote1x = uriTemplates(TWITCH_EMOTE_TEMPLATE).fill({
                            emote_id: replacement.emote,
                            size: '1.0'
                        });
                        rendered += '<img' + this.makeAttributes({
                            'class': 'notCloseable twitchEmote loading',
                            src: emote1x,
                            srcset: emote1x + ' 1x, ' + uriTemplates(TWITCH_EMOTE_TEMPLATE).fill({
                                emote_id: replacement.emote,
                                size: '2.0'
                            }) + ' 2x',
                            title: replacementText,
                            alt: replacementText
                        }) + '>';
                        plainClassName = 'twitchEmoteText';
                        break;
                    }
                    if (plainClassName) {
                        if (options.withPlain) {
                            rendered += ' (' + this.escapeText(replacementText) + ')';
                        } else {
                            rendered += '<span class="' + plainClassName + '">' + this.escapeText(replacementText) + '</span>';
                        }
                    }
                    value = util.stringSlice(part.value, rEnd);
                    index = rEnd;
                }
            }, this);
            if (value) {
                rendered += this.renderTwitchCheer(value, options);
            }
            return rendered;
        } else {
            return this.renderTwitchCheer(part.value, options);
        }
    },
    renderTwitchCheer: function (input, options) {
        if (this.buffer && options.embeds && options.embeds.twitch_tags && options.embeds.twitch_tags.bits) {
            var parts = twitch.splitCheerParts(this.buffer.normalise(), input);
            return _.map(parts, function renderTwitchCheerMap (part) {
                if (part.cheer) {
                    var replacement = '';
                    _.each(['light', 'dark'], function renderTwitchCheerThemes (theme) {
                        var chear1x = twitch.cheerUrl(part.type, part.tier, theme, 1);
                        replacement += '<img' + this.makeAttributes({
                            'class': 'loading twitchEmote twitchEmote--' + theme,
                            src: chear1x,
                            srcset: chear1x + ' 1x, ' + twitch.cheerUrl(part.type, part.tier, theme, 2) + ' 2x',
                            title: part.text,
                            alt: part.text
                        }) + '>';
                    }, this);
                    replacement += ' ';
                    replacement += twitch.cheerValue(part.type, part.tier, part.value);
                    if (options.withPlain) {
                        replacement += ' (' + this.escapeText(part.text) + ')';
                    }
                    return replacement;
                } else {
                    return this.renderEmoji(this.escapeText(part.text), options);
                }
            }, this).join('');
        } else {
            return this.renderEmoji(this.escapeText(input), options);
        }
    },
    renderComicSans: function (input) {
        var re = /(comic sans)/gi;
        var replacement = "<span style=\"font-family:'comic sans ms', 'chalkboard', 'chalkboard se';\">$1</span>";
        return util.stringify(input).replace(re, replacement);
    },
    renderNoEmoji: function (input, options) {
        options = options || {};
        options.noEmoji = true;
        return this.render(input, options);
    },
    renderEmoji: function (input, options) {
        options = options || {};
        if (options.noEmoji) {
            return input;
        }
        return emoji.replace_colons(
            emoji.replace_unified(input)
        );
    },
    prepareCustomEmoji: function (embeds) {
        var customEmoji = embeds && embeds.emoji;
        if (!customEmoji) {
            return;
        }
        var customEmojiJson;
        try {
            customEmojiJson = JSON.parse(customEmoji);
        } catch (exc) {
            // pass
        }
        if (!customEmojiJson || _.isArray(customEmojiJson)) {
            return;
        }
        var offsets = [];
        // [{
        //     url: 'https://example.com/emoji.png',
        //     idx: [
        //         [0,4],
        //         [5,6]
        //     ]
        // }]
        _.each(customEmojiJson, function (json) {
            if (!json.url || !json.url.match(/https:\/\/.+/)) {
                return;
            }
            if (!json.idx || !_.isArray(json.idx)) {
                return;
            }
            _.each(json.idx, function (jsonOffset) {
                if (!jsonOffset || !_.isArray(jsonOffset) || jsonOffset.length !== 2) {
                    return;
                }
                var offset = {
                    url: json.url,
                    start: jsonOffset[0]-0,
                    end: jsonOffset[1]-0
                };
                if (offset.end > offset.start) {
                    offsets.push(offset);
                }
            });
        });
        if (offsets.length) {
            offsets.sort(function (a, b) {
                return a.start - b.start;
            });
            return offsets;
        }
    },

    renderAttachment: function (message, fallback) {
        return attachment.render.call(this, message, fallback);
    },
    renderSlackBlocks: function (message) {
        return slackBlock.render.call(this, message);
    },

    renderLinkify: function (lines, options) {
        options = options || {};
        var embeds, replacements;
        if (options.message) {
            options = _.extend({}, options, {
                embeds: options.message.getEmbeds(),
                replacements: options.message.getReplacements(),
                mention_data: options.message.getMentionData(),
            });
        }
        return this.renderLinkifyWithTextFunction(lines, options, _.bind(function (part, partOptions) {
            var output = this.renderMatches(part, _.extend({}, options, {
                partOptions: partOptions
            }));
            if (options.comicSans) {
                output = this.renderComicSans(output);
            }
            return output;
        }, this));
    },
    renderLinkifyComicSans: function (lines, options) {
        return this.renderLinkify(lines, _.extend({}, options, {
            comicSans: true
        }));
    },
    renderLinkifyProcessor: function (textFunction, lineData, lineEmbeds, embedHtml, textPart, textIndex, options) {
        var urlSplitParts = this.linker.splitTextOnUrls(textPart, textIndex);
        var parts = _.map(urlSplitParts, function (part, index) {
            // Link up URLs
            if (part.url) {
                var bits = this.linker.renderUrl(part.url, options);
                var result;
                if (!bits) {
                    result = textFunction(part, options);
                } else {
                    if (bits.data) {
                        // Delete data already seen in a line
                        // NOTE: this might cause issues in bufferlogcontainer
                        // since we aren't also deleting the classnames that trigger
                        // the data handling, e.g. for twitter
                        if (util.containsEqual(lineData, bits.data)) {
                            delete bits.data;
                        }
                        lineData.push(bits.data);
                    }
                    result = this.linker.makeLinkFromBits(bits.html, bits);
                    if (bits.embed && !util.containsEqual(lineEmbeds, bits.embed)) {
                        lineEmbeds.push(bits.embed);
                        // Add a close button
                        var closeTitle = 'Close ' + bits.className;
                        var close = '<a href="" class="embedClose" title="' + closeTitle + '"></a>';
                        // Add a spinner for images
                        var spin = '';
                        var embed;
                        if (bits.className == 'image') {
                            var embedBits = _.extend({}, bits, {
                                attrs: {
                                    'tabindex': '-1'
                                }
                            });
                            spin = this.linker.makeLinkFromBits(this.embedSpin(), embedBits, 'spin');
                            embed = this.linker.makeLinkFromBits(bits.embed, embedBits);
                        } else {
                            embed = bits.embed;
                        }
                        embedHtml.push(spin + '<span class="directEmbedWrap ' + bits.className + 'Wrap">' + embed + close + '</span>');
                    }
                }
                return result;
            } else {
                return textFunction(part, options);
            }
        }, this);
        return parts.join('');
    },
    renderRedacted: function (message) {
        var redacted = message.getRedacted() || message.getDeletion();
        var title = 'Deleted';
        if (redacted) {
            var from = redacted.get('from');
            var reason = redacted.get('reason');
            var author;
            if (from) {
                author = from;
            } else {
                author = redacted.get('server');
            }
            title += ' by ' + author;
            if (reason) {
                title += ': ' + reason;
            }
            title += ' (' + redacted.getDate().formatFullDate() + ')';
        }
        var attribs = {
            title: title,
            'class': 'message-redacted'
        };
        return '<span' + this.makeAttributes(attribs) + '>(deleted)</span> ';
    },
    renderLinkifyWithTextFunction: function (lines, options, textFunction) {
        lines = $.makeArray(lines);
        // Format parts
        var formattedLines = [];
        _.each(lines, function (text) {
            var embedHtml = [];
            var lineData = [];
            var lineEmbeds = [];
            var formattedText = IRCFormatter.renderHtml(text, _.extend({}, options, {
                processor: _.bind(this.renderLinkifyProcessor, this, textFunction, lineData, lineEmbeds, embedHtml)
            }));
            if (options.message) {
                var edit = options.message.getEditOrig();
                var deleted = options.message.isDeletedOrRedacted();
                if (edit) {
                    var title = edit.get('previous_msg') + ' (' + edit.getDate().formatFullDate() + ')';
                    var attribs = {
                        title: title,
                        'class': 'message-edited'
                    };
                    formattedText += ' <span' + this.makeAttributes(attribs) + '>(edited)</span>';
                }
                if (deleted) {
                    formattedText = this.renderRedacted(options.message) + formattedText;
                }
            }
            if (options.embeds && options.embeds.files) {
                _.each(options.embeds.files, function (file) {
                    if (!file.id) {
                        debug.warn("Invalid embedded file", file);
                        return;
                    }
                    var fw = new FileWrapper(file);
                    var fileData = fw.toJSON();
                    delete fileData.properties;
                    fileData.width = fw.getWidth();
                    fileData.height = fw.getHeight();
                    embedHtml.push('<span class="fileWrap loading">' +
                        this.linker.makeLinkFromBits(this.embedSpin(), {
                            url: file.url,
                            className: 'file',
                            loading: true,
                            target: '_blank',
                            data: fileData
                        }) +
                        '</span>');
                }, this);
            }
            formattedLines.push(formattedText + embedHtml.join(''));
        }, this);
        // Join lines back up and return
        var formattedText = formattedLines.join('<br>');
        return formattedText;
    },
    linkModel: function (model, options) {
        var name = model.getName();
        if (!name) {
            return '[unknown]';
        }
        options = options || {};
        var data = _.extend({}, options.data);
        var className = "buffer bufferLink";
        if (options.className) {
            className += ' ' + options.className;
        }
        var style;
        if (options.styles) {
            style = _.map(options.styles, function (v, k) {
                return k + ': ' + v + ';';
            }).join(' ');
        }
        var title = options.title;
        if (title === undefined) {
            title = model.getTitle();
        }
        if (!options.hasDataParent) {
            data['cid'] = model.getCid();
            data['name'] = data['name'] || name;
            if (model instanceof Buf || model instanceof Message || model instanceof User) {
                data['bid'] = model.bid();
            }
        }
        var attributes = _.extend({}, options.attr, {
            href: model.url(),
            style: style,
            'class': className,
            title: title,
            data: data
        });
        var displayName = options.name || model.getDisplayName();
        var suffix = options.suffix || '';
        return this.linker.make(
            this.escapeText(util.truncate(IRCFormatter.strip(displayName), 64)) + suffix,
            attributes,
            options.button
        );
    }
};
$.extend(Formatter, {
    RTL_REGEX: /[\u05BE\u05C0\u05C3\u05D0-\u05EA\u05F0-\u05F4\u061B\u061F\u0621-\u063A\u0640-\u064A\u066D-\u066F\u0671-\u06D5\u06DD\u06E5-\u06E6\u06FA-\u06FE\u0700-\u070D\u0710\u0712-\u072C\u0780-\u07A5\u07B1\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFC\uFE70-\uFE74\uFE76-\uFEFC]/,
    PRECISION_STRINGS: $.extend({}, $.timeago.settings.strings, {
        prefixFromNow: 'in',
        suffixFromNow: null,
        second: '%d second',
        seconds: '%d seconds',
        minute: '%d seconds',
        hour: '%d minutes'
    }),
    HOW_LONG_STRINGS: $.extend({}, $.timeago.settings.strings),
    HOW_LONG_STRINGS_PREFIX: $.extend({}, $.timeago.settings.strings, {
        prefixAgo: "for",
        suffixAgo: null
    })
});

document.body.addEventListener(
    'load',
    function (e) {
        if (e.target.className == 'irccloud_avatar') {
            var parent = $(e.target.parentNode);
            // Show image avatar, adjust class name
            parent.removeClass('imageAvatar--loading').addClass('imageAvatar--loaded');
            // Hide letter avatar
            parent.next('.letterAvatar--internal').addClass('letterAvatar--internal_fallback');
            parent.next('.letterAvatar--external').addClass('letterAvatar--external_fallback');
            parent.trigger('reflowImageContainer');
        }
    },
    true // <-- useCapture
);
document.body.addEventListener(
    'error',
    function (e) {
        if (e.target.className == 'irccloud_avatar') {
            var parent = $(e.target.parentNode);
            // Adjust class name, already hidden and letter avatar already shown
            parent.removeClass('imageAvatar--loading').addClass('imageAvatar--error');
        }
    },
    true // <-- useCapture
);

module.exports = Formatter;



//////////////////
// WEBPACK FOOTER
// ./app/src/format/formatter.js
// module id = 5gSh
// module chunks = 1